import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentsModule } from '../../components/components.module';
import { PI_MODULES } from '../base/prime-modules';
import { EstadoCuentaComponent } from './reportes/estado-cuenta/estado-cuenta.component';
import { AsociacionesRoutingModule } from './asociaciones-routing.module';




@NgModule({
  declarations: [
    EstadoCuentaComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    AsociacionesRoutingModule,
    ...PI_MODULES
  ]
})
export class AsociacionesModule { }
